import { AuthService } from '../services/auth.service';
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';


export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  
  authService.checkAuthentication();

  return authService.isAuthenticated$;
};
